import { render, staticRenderFns } from "./UploadInflation.vue?vue&type=template&id=39546793&"
import script from "./UploadInflation.vue?vue&type=script&lang=js&"
export * from "./UploadInflation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports